var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGraphGrowth({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.25V6.75H19.9394L13.5 13.1894L10.2802 9.96975C10.2106 9.90008 10.128 9.84481 10.037 9.80709C9.94601 9.76938 9.84849 9.74997 9.75 9.74997C9.65151 9.74997 9.55399 9.76938 9.463 9.80709C9.37202 9.84481 9.28936 9.90008 9.21975 9.96975L1.5 17.6894L2.56058 18.75L9.75 11.5606L12.9697 14.7803C13.0394 14.8499 13.122 14.9052 13.213 14.9429C13.304 14.9806 13.4015 15 13.5 15C13.5985 15 13.696 14.9806 13.787 14.9429C13.878 14.9052 13.9606 14.8499 14.0303 14.7803L21 7.81057V12.75H22.5V5.25H15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGraphGrowth);
export default __webpack_public_path__ + "static/media/ic-graph-growth.1b3cb079d9c705e8b1d31517b7466219.svg";
export { ForwardRef as ReactComponent };